import { render } from "./DetailsOffreSection.vue?vue&type=template&id=1894d38c"
import script from "./DetailsOffreSection.vue?vue&type=script&lang=js"
export * from "./DetailsOffreSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__